import { __assign } from "tslib";
import { Url } from '@wix/da-url';
var backendPageToReadableKeyMap = {
    dyw: 'watch',
    dd: 'dailyDeviations',
    rfy: 'home',
};
function findNewContentFor(key, mainNavNewContent) {
    return mainNavNewContent === null || mainNavNewContent === void 0 ? void 0 : mainNavNewContent.find(function (_a) {
        var _b;
        var page = _a.page;
        return ((_b = backendPageToReadableKeyMap[page]) !== null && _b !== void 0 ? _b : page) === key;
    });
}
export function getDefaultMainNavigation() {
    var defaults = [
        {
            key: 'home',
            url: Url.browseHomeLink(),
        },
        {
            key: 'watch',
            url: Url.browseDeviantsYouWatchLink(),
            restrictLoggedIn: true,
            pageType: 'watch',
        },
        {
            key: 'shop',
            url: Url.shopLink(),
            withFeature: 'shop_networkbar',
            betaBadge: 'new',
        },
        {
            key: 'dreamup',
            url: Url.dreamupLink(),
            withFeature: 'ai_art_generator',
            betaBadge: 'new',
        },
        {
            key: 'dailyDeviations',
            url: Url.browseDailyDeviationsLink(),
            restrictLoggedIn: true,
            pageType: 'daily-deviations',
        },
        {
            key: 'topics',
            url: Url.browseTopicsLink(),
            pageType: 'topicList',
        },
        {
            key: 'popular',
            url: Url.browsePopularLink(),
            restrictLoggedIn: true,
        },
    ];
    return defaults;
}
export function generateMainNavigation(mainNavNewContent) {
    return getDefaultMainNavigation().map(function (menuItem) {
        var newContent = findNewContentFor(menuItem.key, mainNavNewContent);
        if (!newContent) {
            return menuItem;
        }
        return __assign(__assign({}, menuItem), { url: newContent.url, hasNewContent: true, turnOffWithThisPageview: newContent.turnOffWithThisPageview });
    });
}
//# sourceMappingURL=helpers.js.map